module.exports = __webpack_public_path__ + "static/media/LK__Timer-clock.17506a9c.svg";